import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { Account } from '../../model/account';
import { AccountService } from '../../services/account.service';
import * as accountInformationActions from '../actions';

@Injectable()
export class AccountInformationEffect {
  @Effect()
  public loadAccountInformation$ = this.actions$.pipe(
    ofType<accountInformationActions.LoadAccountInformation>(
      accountInformationActions.LOAD_ACCOUNT_INFORMATION
    ),
    switchMap(() =>
      this.accountService.getAccount().pipe(
        map(
          (account: Account) =>
            new accountInformationActions.LoadAccountInformationSuccess(account)
        ),
        catchError((error: any) =>
          of(new accountInformationActions.LoadAccountInformationFail(error))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private accountService: AccountService
  ) {}
}
